// src/components/TrendingSidebar.js
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom"; // ✅ Required for navigation

const TrendingSidebar = () => {
  const [trending, setTrending] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchTrending = async () => {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_API_URL}/trending/posts?hours=24&limit=10`
        );

        const data = await res.json();

        if (data.success && Array.isArray(data.posts)) {
          setTrending(data.posts);
        } else {
          setTrending([]);
        }
      } catch (err) {
        console.error("❌ Trending fetch error:", err);
        setTrending([]);
      } finally {
        setLoading(false);
      }
    };

    fetchTrending();
  }, []);

  return (
    <div className="sidebar-card">
      <h3>🔥 Trending Today</h3>

      {loading ? (
        <p>Loading...</p>
      ) : trending.length === 0 ? (
        <p className="trending-empty">
          No trending activity right now.
          <br />
          <span>New activity will appear here automatically.</span>
        </p>
      ) : (
        <ul className="trending-list">
          {trending.map((post) => (
            <li
              key={post.id}
              className="trending-item"
              onClick={() => navigate(`/post/${post.id}`)}
            >
              <div className="trending-text">
                <div className="trending-meta">
                  <span>@{post.username}</span>
                  <span className="trending-score">⭐ {post.score}</span>
                </div>

                <div className="trending-snippet">
                  {post.content && post.content.length > 120
                    ? post.content.slice(0, 120) + "…"
                    : post.content || "(no text)"}
                </div>

                <div className="trending-stats">
                  👍 {post.like_count} · 💬 {post.reply_count} · 🔁 {post.repost_count}
                </div>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default TrendingSidebar;
